import { render } from "./AreasDistrictAvailableDaysPage.vue?vue&type=template&id=3b3a7822&scoped=true"
import script from "./AreasDistrictAvailableDaysPage.vue?vue&type=script&lang=js"
export * from "./AreasDistrictAvailableDaysPage.vue?vue&type=script&lang=js"

import "./AreasDistrictAvailableDaysPage.vue?vue&type=style&index=0&id=3b3a7822&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\loop Company\\Apps\\cms-dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b3a7822"]])

export default __exports__